export default __webpack_public_path__ + "static/avatar-kortical-team2--mobile-dbda6214498de907c651931ee9e55f45.jpg";